import(/* webpackMode: "eager", webpackExports: ["InstantFortuneSlip"] */ "/vercel/path0/app/generator/InstantFortuneSlip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdUnit"] */ "/vercel/path0/components/AdUnit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DynamicBackgroundEffects"] */ "/vercel/path0/components/DynamicBackgroundEffects.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
